import BasicTableContainer from "../../../../../Components/Forms&Table/Tables/ReactstrapTables/BasicTables/BasicTableContainer";

const BasicTables = () => {
  return <BasicTableContainer />;
};

export default BasicTables;
